<template>
    <div>
        <div class="ins-process">
            投保流程
        </div>
        <div class="process-content">
            <div class="title">1.投保信息录入</div>
            <div class="detail">客户在投保页面填写用户信息，客服会联系您出单；</div>
            <div class="title">2.缴费获取预约大保单</div>
            <div class="detail">客服在保险公司外网系统录单，客户扫码直接支付保费给保险公司，获得电子保单；</div>
            <div class="title">3.运输前录货运信息申报</div>
            <div class="detail">运输前录单申报获取申报单，从预缴保费中根据距离预扣保费金额；</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InsProcess"
    }
</script>

<style scoped lang="scss">
    .ins-process{
        height: 12vw;
        padding-left: 10.67vw;
        margin-top: 2.67vw;
        line-height: 12vw;
        text-align: left;
        font-size: 4.27vw;
        font-weight: bold;
        background: url(../assets/process.png) no-repeat 5.33vw center #ffffff;
        background-size: 4vw;
    }
    .process-content{
        padding: 0 5.33vw 2.67vw 10.67vw;
        line-height: 8vw;
        text-align: left;
        background: #ffffff;
        .title{
            color: #333333;
            background: #ffffff;
        }
        .detail{
            color: #999999;
            /*text-indent: 5.33vw;*/
            a{
                color: #999999;
                text-decoration: none;
            }
            /*font-size: 3.2vw;*/
        }
    }
</style>